import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ConfirmComponent,
  FlagComponent,
  ProfileIcon,
  SelectComponent,
  DeleteAccountComponent,
  CancelBookingComponent,
  AvatarPhotoComponent,
  ImageCropperComponent,
  PaginationComponent,
  SwitcherComponent,
  CalendarComponent,
  HoursComponent,
  SuccessComponent,
  SpinnerComponent,
  AppointmentStatusComponent,
  SearchComponent,
  TabsComponent,
  TextInputComponent,
  TextareaInputComponent,
  CheckboxInputComponent
} from './components';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { BusinessService, CategoryService, ErrorInterceptor, JwtInterceptor, AppointmentService } from '@core/services';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { UploadFileDirective } from '@core/directives';
import {
  ArraySortPipe,
  DateLocalPipe,
  ImagePathFormatter,
  MinuteToHourPipe,
  ServicePriceTextPipe,
  TimeDiffPipe,
  TotalPriceFromServicesPipe,
} from '@core/pipes';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbDatepickerModule, NgbPaginationModule, NgbTimepicker, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from './services/notificaion.service';
import { NotificationComponent } from './components/notifications/notification.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { FullCalendarModule } from '@fullcalendar/angular';
import { MatMenuModule } from '@angular/material/menu';
import { AccordionComponent } from './components/accordion/accordion.component';
import { CloseIconComponent } from "../shared/icons/close-icon.component";
@NgModule({
  declarations: [
    SelectComponent,
    FlagComponent,
    ConfirmComponent,
    ProfileIcon,
    DeleteAccountComponent,
    CancelBookingComponent,
    AvatarPhotoComponent,
    ImageCropperComponent,
    UploadFileDirective,
    ImagePathFormatter,
    TimeDiffPipe,
    ArraySortPipe,
    MinuteToHourPipe,
    ServicePriceTextPipe,
    TotalPriceFromServicesPipe,
    DateLocalPipe,
    PaginationComponent,
    SwitcherComponent,
    CalendarComponent,
    HoursComponent,
    SuccessComponent,
    SpinnerComponent,
    AppointmentStatusComponent,
    NotificationComponent,
    SearchComponent,
    TabsComponent,
    AccordionComponent,
    TextInputComponent,
    TextareaInputComponent,
    CheckboxInputComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    ImageCropperModule,
    NgbPaginationModule,
    FullCalendarModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatMenuModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    CloseIconComponent
],
  exports: [
    SelectComponent,
    FlagComponent,
    ConfirmComponent,
    ProfileIcon,
    AvatarPhotoComponent,
    UploadFileDirective,
    ImagePathFormatter,
    TimeDiffPipe,
    ArraySortPipe,
    MinuteToHourPipe,
    ServicePriceTextPipe,
    TotalPriceFromServicesPipe,
    DateLocalPipe,
    PaginationComponent,
    SwitcherComponent,
    CalendarComponent,
    HoursComponent,
    SuccessComponent,
    SpinnerComponent,
    AppointmentStatusComponent,
    NotificationComponent,
    SearchComponent,
    TabsComponent,
    MatMenuModule,
    AccordionComponent,
    NgbTimepickerModule,
    TextInputComponent,
    TextareaInputComponent,
    CheckboxInputComponent
  ],
  providers: [
    CategoryService,
    NotificationService,
    BusinessService,
    AppointmentService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }
  ],
})
export class CoreModule {
}
